import { render, staticRenderFns } from "./zhkq.vue?vue&type=template&id=193308b6&scoped=true&"
import script from "./zhkq.vue?vue&type=script&lang=js&"
export * from "./zhkq.vue?vue&type=script&lang=js&"
import style0 from "./zhkq.vue?vue&type=style&index=0&id=193308b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193308b6",
  null
  
)

export default component.exports